export default __webpack_public_path__ + "static/media/invoiceiconnew.8d3eb439.svg";